import * as Yup from "yup";
import { GET_EMPLOYEE_DEPARTMENTS, GET_EMPLOYEE_DESIGNATIONS, GET_LIVECLASS_PACKAGES, GET_PROJECTS_LIST, GET_TEACHERS, GET_VENDOR_ACCOUNTS, GET_VENDOR_PROJECT_USERS, GET_VENDOR_USERS, GET_VENDORS } from "utils/graphql/services/live-classes/queries";
import authClientService from "utils/graphql/authClient";

export function toNumberIdArray(ids: string[] | string | number | number[]): number[] {
    return (Array.isArray(ids) ? ids : [ids])
        .filter((id: any) => id !== null && id !== undefined && id !== "")
        .map(Number);
}

export const table = {
    primaryData: [
        {
            title: "ID",
            value: "id",
            type: "configue",
        },
        {
            title: "Package Name",
            value: "packageName",
            // type: "configue",
        },
        {
            title: "Status",
            value: "status",
            type: "configue",
            renderAs: "status-chip",
            statusPreset: "meetingStatus",
        },
        {
            title: "Meeting Title",
            value: "meetingTitle",
            type: "configue",
        },
        {
            title: "Is Active",
            value: "isActive",
            type: "configue",
            renderAs: "status-chip",
        },
        {
            title: "Schedule Actions",
            value: "ScheduleActions",
            type: "configue",
        },
        {
            title:"Host Link",
            value:"scheduleCopyAction",
            type:"configue"
        }
        
    ],
    secondaryData: [
        {
            title: "Live Session ID",
            value: "liveSessionId",
            type: "configue",
        },
        {
            title: "Department Name",
            value: "employeeDepartmentName",
            type:"configue"
        },
        {
            title: "Designation Name",
            value: "employeeDesignationName",
            type:"configue"
        },
        
        {
            title: "Scheduled Start Time",
            value: "scheduledStartTime",
            type: "configue",
        },
        {
            title: "Scheduled End Time",
            value: "scheduledEndTime",
            type: "configue",
        },
        {
            title: "Created At",
            value: "createdAt",
            type: "configue",
        },
        {
            title: "Updated At",
            value: "updatedAt",
            type: "configue",
            name: "updatedAt",
        },
        {
            title: "Created By",
            value: "createdByName",
            // type: "configue",
        },
        {
            title: "Updated By",
            value: "updatedByName",
            // type: "configue",
            name: "updatedByName",
        },
       
    ],
};

export type Nl3PackageSchedule = {

    currentTime: Date;
    nlearn3LiveclassPackageIds: string;
    projectIds: string;
    vendorId: string;
    vendorAccountId: string;
    start_date_time: string;
    end_date_time: string;
    meetingTitle: string;
    subjectName: string;
    meetingSubTitle: string;
    thumbnailUrl: string;
    notesUrl: string;
    departmentId: string;
    designationId: string;
    teacherId: string;
    vendorUserId: string;

};

export const Nl3PackageScheduleInitialValues: Nl3PackageSchedule = {
    currentTime: new Date(), 
    nlearn3LiveclassPackageIds: "",
    projectIds: "",
    vendorId: "",
    vendorAccountId: "",
    start_date_time: "",
    end_date_time: "",
    meetingTitle: "",
    subjectName: "",
    meetingSubTitle: "",
    thumbnailUrl: "",
    notesUrl: "",
    departmentId: "",
    designationId: "",
    teacherId: "",
    vendorUserId: "",
};

export const Nl3PackageScheduleMandatoryFields = [
    { id: "nlearn3LiveclassPackageIds" },
    { id: "projectIds" },
    { id: "vendorId" },
    { id: "vendorAccountId" },
    { id: "start_date_time" },
    { id: "end_date_time" },
    { id: "meetingTitle" },
    { id: "subjectName"},
    // { id: "meetingSubTitle" },
    { id: "departmentId" },
    { id: "designationId" },
    { id: "teacherId" },
    { id: "vendorUserId" },
];

export const Nl3PackageScheduleValidationSchema = Yup.object().shape({
});


export const Nl3PackageScheduleProperties = [
    {
        id: "vendorId",
        type: "single-select-search",
        label: "Vendor *",
        keyValue: { label: "name", value: "id" },
        query: GET_VENDORS,
        gqlKey: "getVendors",
        dataKey: "vendors",
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
    {
        id: "vendorAccountId",
        type: "single-select-search",
        label: "Vendor Account *",
        query: GET_VENDOR_ACCOUNTS,
        gqlKey: "getVendorAccounts",
        dataKey: "vendorAccounts",
        keyValue: { label: "associatedDomainName", value: "id" },
        searchFieldKey: "associatedDomainName",
        dependentOn: "vendorId", // 🔥 ONLY THIS IS REQUIRED
        formatDependentPayload: (vendorId: string | number) => ({
            vendorId: Number(vendorId),
        }),
        strictDependency: true,
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
    {
        id: "start_date_time",
        type: "date-time-picker2",
        label: "Scheduled Start Time ",
        className: "name-styles",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        maxDateTime: "end_date_time",
        restrictError: true,
        required: true
    },
    {
        id: "end_date_time",
        type: "date-time-picker2",
        label: "Scheduled End Time ",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        minDateTime: "start_date_time",
        restrictError: true,
        required: true
    },
    {
        id: "projectIds",
        type: "multi-select-search",
        label: "Project *",
        keyValue: { label: "name", value: "id" },
        query: GET_PROJECTS_LIST,
        gqlKey: "getProjects",
        dataKey: "projects",
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
    {
        id: "nlearn3LiveclassPackageIds",
        type: "multi-select-search",
        label: "Liveclass Package",
        keyValue: { label: "packageDropdownLabel", value: "id" },
        query: GET_LIVECLASS_PACKAGES,
        gqlKey: "getLiveclassPackages",
        dataKey: "liveclassPackages",
        searchFieldKey: "searchName",
        className: "name-styles",
        dependentOn: "projectIds",
        strictDependency: false,
        formatDependentPayload: (projectIds: string[] | string) => ({
            projectIds: toNumberIdArray(projectIds),
        }),
        formatData: (liveclassPackages: any[]) => {
            if (!liveclassPackages) return [];
            return liveclassPackages.map((liveclassPackage: any) => ({
                ...liveclassPackage,
                packageDropdownLabel: `${liveclassPackage?.name || ""} - ${liveclassPackage?.packageStudentsCount ?? 0}`,
            }));
        },
        breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
        required: false,  
    },
    {
        id: "meetingTitle",
        type: "text",
        label: "Meeting Title",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
    {
        id:"subjectName",
        type: "text",
        label: "Subject Name",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true
    },
    {
        id: "departmentId",
        type: "single-select-search",
        label: "Department",
        keyValue: { label: "name", value: "id" },
        query: GET_EMPLOYEE_DEPARTMENTS,
        client: authClientService,
        gqlKey: "getEmployeeDepartments",
        dataKey: "employeeDepartments",
        searchFieldKey: "name",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
    {
        id: "designationId",
        type: "single-select-search",
        label: "Designation",
        keyValue: { label: "name", value: "id" },
        query: GET_EMPLOYEE_DESIGNATIONS,
        client: authClientService,
        gqlKey: "getEmployeeDesignations",
        dataKey: "employeeDesignations",
        searchFieldKey: "name",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
    {
        id: "teacherId",
        type: "single-select-search",
        label: "Host *",
        keyValue: {
            label: "employeeDropdownLabel",
            value: "employeeDropdownValue"
        },
        query: GET_TEACHERS,
        gqlKey: "getTeachers",
        dataKey: "teachers",
        client: authClientService,
        resolveByIdKey: "id",
        dependentOn: ["departmentId", "designationId"],
        searchFieldKey: "searchName",
        strictDependency: false,
        extraPayload: { isArchived: false },
        formatDependentPayload: ([departmentId, designationId]: any) => {
            return {
                ...(departmentId && { employeeDepartmentId: Number(departmentId) }),
                ...(designationId && { employeeDesignationId: Number(designationId) }),
            };
        },
        formatData: (teachers: any[]) => {
            if (!teachers) return [];
            return teachers.map((teacher: any) => ({
                ...teacher,
                employeeDropdownLabel: `${teacher?.employee?.employeeId || ""} ${teacher?.employee?.firstName || ""} ${teacher?.employee?.lastName || ""}`.trim(),
                employeeDropdownValue: teacher?.id
            }));
        },
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
    {
        id: "vendorUserId",
        type: "single-select-search",
        label: "Licensed Vendor User *",
        keyValue: { label: "vendorUserLabel", value: "vendorUserId" },
        formatData: (records: any[]) =>
            records.map((item: any) => ({
                ...item,
                vendorUserLabel: item.projectName ? `${item.vendorEmail} - ${item.projectName}` : item.vendorEmail,
            })),
        query: GET_VENDOR_PROJECT_USERS,
        gqlKey: "getVendorProjectUsers",
        dataKey: "vendorProjectUsers",
        searchFieldKey: "vendorEmail",
        resolveByIdKey: "vendorUserId",
        extraPayload: { userType: "Licensed",  },
        dependentOn: ["projectIds", "vendorId"],
        formatDependentPayload: ([projectIds, vendorId]: any) => {
            const ids = toNumberIdArray(projectIds);
            return {
                userType: "Licensed",
                ...(ids.length && { projectIds: ids }),
                ...(vendorId && { vendorId: Number(vendorId) }),
            };
        },
        strictDependency: false,
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
];

export function hasAtLeastOneValue(obj: any, keys: any[]) {
    return keys.some((key) => {
        const value = obj[key];
        return (
            value !== "" &&
            value !== null &&
            value !== undefined &&
            !(Array.isArray(value) && value.length === 0) &&
            !(Array.isArray(value) && value.every(v => v === null))
        );
    });
}
